import React from 'react'
import { Badge } from 'reactstrap'

export default function OrderStatusBadge(props) {
  return (
    <Badge color={props.color} data-testid="order-status-badge">{props.status}</Badge>
  )
}
